import React from 'react';
import TextField from '../BaseInputs/TextField';
import NumberStepper from '../BaseInputs/NumberStepper';
import TextField2 from '../BaseInputs/TextField2';
import TextBox from '../BaseInputs/TextBox';
import InputWithCheckBox from '../BaseInputs/InputWithCheckBox';
import IntToDateInputElement from '../BaseInputs/IntToDateInputElement';
import BusinessPhoneField from '../BaseInputs/BusinessPhoneField';
import PhoneNumberInputField from '../BaseInputs/PhoneNumberInputField';
import PlaceHolderField from '../BaseInputs/PlaceHolderField';
import ImportListTextField from '../BaseInputs/ImportListTextField';
import InfoCalloutField from '../InfoCalloutField';
import InvoiceReferenceTemplateField from '../BaseInputs/InvoiceReferenceTemplateField';

/** DS integer field: centered value with −/+ steppers (InputTypesEnum.Number / Number2).
 * Pass showSteppers=false (InputTypesEnum.NumberWithoutSteppers) for typed ids/codes. */
export const renderNumberStepper = (props, showSteppers = true) => (
  <NumberStepper
    fieldName={props.fieldName}
    onChange={props.onChange}
    value={props.value}
    placeholder={props.placeholder}
    showSteppers={showSteppers}
  />
);

export const renderTextField = (props, fieldType, readOnly) => (
  <TextField
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    placeholder={props.placeholder}
    value={props.value}
    editedItem={props.editedItem}
    fieldType={fieldType}
    readonly={readOnly}
    textBeforeInput={props.textBeforeInput}
    maxLength={props.maxLength}
  />
);

/** An automatic invoicing setup's reference, with + Month / + Year and this month's name (InvoiceReferenceTemplate). */
export const renderInvoiceReferenceTemplateField = (props) => (
  <InvoiceReferenceTemplateField
    className={props.className}
    fieldName={props.fieldName}
    maxLength={props.maxLength}
    onChange={props.onChange}
    placeholder={props.placeholder}
    value={props.value}
  />
);

export const renderImportListTextField = (props) => (
  <ImportListTextField
    className={props.className}
    fieldName={props.fieldName}
    labelText={typeof props.labelText === 'string' ? props.labelText : ''}
    onChange={props.onChange}
    placeholder={props.placeholder}
    value={props.value}
  />
);

export const renderTextField2 = (props) => (
  <TextField2
    className={props.className}
    fieldName={props.fieldName}
    onChange={props.onChange}
    placeholder={props.placeholder}
    fieldType={props.fieldType}
    value={props.value}
    editedItem={props.editedItem}
  />
);

export const renderTextBox = (props, readOnly = false) => (
  <TextBox
    className={props.className}
    numberOfRows={props.numberOfRows}
    placeholder={props.placeholder}
    value={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
    fieldName={props.fieldName}
    readOnly={readOnly}
  />
);

export const renderInputWithCheckBox = (props, type = 'text') => (
  <InputWithCheckBox
    value={props.value}
    fieldName={props.fieldName}
    onChange={props.onChange}
    editedItem={props.editedItem}
    placeholder={props.placeholder}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    getCheckBoxFieldsObject={props.getCheckBoxFieldsObject}
    fieldType={type}
  />
);

export const renderLinkField = (props) => {
  // Link text is the filename of the field's own value (falling back to a generic label) —
  // previously this hardcoded one consumer's template path, mislabeling every other Link field.
  const fileName = props.value ? String(props.value).split('/').pop() : 'Template';

  return (
    <div className={props.className}>
      <a
        href={props.value}
        className={props.className}
        target='_blank'
        rel='noopener noreferrer'
      >
        {fileName}
      </a>
    </div>
  );
};

export const renderIntToDateInputElementField = (props) => (
  <IntToDateInputElement
    onChange={(value) => props.onChange(props.fieldName, value)}
    value={props.value}
  />
);

export const renderBusinessPhoneField = (props) => (
  <BusinessPhoneField
    value={props.value}
    className={props.className}
    onChange={(value) => props.onChange(props.fieldName, value)}
    placeholder={props.placeholder}
  />
);

export const renderPhoneNumberField = (props) => (
  <PhoneNumberInputField
    value={props.value}
    className={props.className}
    onChange={(value) => props.onChange(props.fieldName, value)}
    placeholder={props.placeholder}
  />
);

export const renderPlaceHolderField = (props) => (
  <PlaceHolderField
    className={props.className}
    fieldName={props.fieldName}
  />
);

export const renderNotesField = (props) => <p className='w-100 p-1 border rounded'>{props.value}</p>;

export const renderEmptySpace = () => <div> </div>;

// Generic info-card field: the window description's buildContent(item) returns
// { paragraphs (strings, **bold** markers allowed), facts?, chips?, chipsLabel?, imageSrc?, imageAlt? }.
export const renderInfoCallout = (props) => {
  const content = (typeof props.buildContent === 'function' ? props.buildContent(props.editedItem) : null) ?? {};
  return (
    <InfoCalloutField
      paragraphs={content.paragraphs}
      facts={content.facts}
      chips={content.chips}
      chipsLabel={content.chipsLabel ?? 'countries'}
      imageSrc={content.imageSrc}
      imageAlt={content.imageAlt}
    />
  );
};
